import { Builder } from '@builder.io/react';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedCurrency } from '../../../../../store/user';
import ReactSelect from 'react-select';
import SelectCurrency from '../../../../general/selectCurrency';
import useHandleAddProduct from '../../../../../utils/handleAddProduct';
import { selectProducts } from '../../../../../store/products';
import ShowCurrencies from '../../../../../utils/showCurrencies';
import useCart from '../../../../../hooks/cart/useCart';
import { openSheet } from '../../../../../store/sheetToggler';
import getSymbolFromCurrency from 'currency-symbol-map';
import { ProductBoxMini } from '../../../../../pages/home/components/productBoxMini';

const styles = {
  menuList: base => ({
    ...base,
    '::-webkit-scrollbar': {
      width: '6px',
      height: '0px',
    },
    '::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '::-webkit-scrollbar-thumb': {
      background: '#888',
    },
    '::-webkit-scrollbar-thumb:hover': {
      background: '#555',
    },
  }),
};

const CountriesWidget = props => {
  /* ----------------------------- Start variables ---------------------------- */
  const {
    addToCart = true,
    suggestedPrices = '70,160,320',
    mode = 'one-off',
    defaultPrice,
    hideFlag = true,
    title = '',
    hideTitle = true,
    countriesInfo = [],
    pricingFilter = false,
  } = props;
  const [allProducts, setAllProducts] = useState([]);
  const [addProduct] = useHandleAddProduct();
  const products = useSelector(state => selectProducts(state));
  const [productsList, setProductsList] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isLoadedImage, setIsLoadedImage] = useState(false);
  const [prevImage, setPrevImage] = useState(null);
  const [hideFlagState, setHideFlagState] = useState(hideFlag);
  const [selectedProduct, setSelectedProduct] = useState({
    creator: countriesInfo[0]?.creator,
    label: '',
    value: '',
  });
  const [currentProduct, setCurrentProduct] = useState({
    creator: countriesInfo[0]?.creator,
    label: '',
    value: '',
  });
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [currentCurrency, setCurrentCurrency] = useState();
  const [priceOptions, setPriceOptions] = useState([70, 160, 320]);
  const [selectedPrice, setSelectedPrice] = useState(defaultPrice || 1);
  const [productAmount, setProductAmount] = useState(defaultPrice);
  const [productQty, setProductQty] = useState(1);
  const [finalDescription, setFinalDescription] = useState('');
  const [isInputChanged, setIsInputChanged] = useState(false);
  const [isGeneralProduct, setIsGeneralProduct] = useState(true);
  const [hasValidatedProduct, setHasValidatedProduct] = useState(false);
  const [defaultPriceGeneral, setDefaultPriceGeneral] = useState(1);
  const dispatch = useDispatch();
  const { handleAddToGiving: handleAddToGivingCart, handleCheckProduct, handleRemoveProduct } = useCart();

  // Added for recurring modes
  const suggestedRecurringModes = [
    { value: 'one-off', label: 'Single' },
    { value: 'month', label: 'Monthly' },
  ];
  const [selectedRecurring, setSelectedRecurring] = useState(() => {
    return suggestedRecurringModes.find(item => item.value === mode) || suggestedRecurringModes[0];
  });

  /* ------------------------------ Start methods ----------------------------- */
  const handleSelectedProduct = value => {
    const matched = allProducts.find(item => item.id === value.value);
    // console.log('on change products======', value, matched);
    if (matched) {
      const isValid = matched.usd === 1 && matched.gbp === 1 && matched.eur === 1 && matched.aud === 1 && matched.cad === 1;
      setIsGeneralProduct(isValid); // 👈 will toggle donation UI vs fallback
      setSelectedProduct(matched);
    }
    setDefaultPriceGeneral(1);
    setCurrentProduct(value);
  };
  const handleAddNewProduct = () => {
    let tempProduct = { ...selectedProduct };
    let quantity = 1;

    if (isGeneralProduct) {
      // General products (donations)
      quantity = Number(productAmount) || 1;
    } else {
      // Non-general products (bundles)
      quantity = productQty;
    }

    tempProduct = {
      ...tempProduct,
      quantity: quantity,
      recurring: selectedRecurring.value,
    };

    if (addToCart) {
      handleAddToGivingCart(tempProduct, 'custom');
      dispatch(openSheet());
    } else {
      addProduct({ product: tempProduct, currency: currentCurrency });
    }
  };
  const handleAmountKeyDown = e => {
    if (['e', 'E', '+', '-', '.'].includes(e.key)) {
      e.preventDefault();
    }
  };
  const handleAmountChange = e => {
    const regex = /^$|^[1-9][0-9]*$/;
    if (regex.test(e.target.value)) {
      setProductAmount(e.target.value);
      setSelectedPrice(null);
      setIsInputChanged(true);
    }
  };
  const getAllProducts = products => {
    if (!products) return;
    let tempProductsDetailsList = [];
    let tempProductsList = [];
    // extract all creators from countriesInfo
    const creators = countriesInfo.map(c => c.creator);
    // console.log('in get product line 140=======', creators, countriesInfo, countryData);
    products.forEach(item => {
      item.sub_categories.forEach(inner_item => {
        inner_item.products.forEach(inner_item_product => {
          if (Number(inner_item_product.status) === 1) {
            if (creators.includes(inner_item_product.creator)) {
              // console.log('in loop====', inner_item_product.creator);
              tempProductsDetailsList.push(inner_item_product);
              tempProductsList.push({
                value: inner_item_product.id,
                label: inner_item_product.name,
                creator: inner_item_product.creator,
              });
            }
          }
        });
      });
    });
    tempProductsList.sort((a, b) => {
      return creators.indexOf(a.creator) - creators.indexOf(b.creator);
    });
    tempProductsDetailsList.sort((a, b) => {
      return creators.indexOf(a.creator) - creators.indexOf(b.creator);
    });
    // 🔥 Set selection - Find and set the default product properly
    let defaultProduct = null;
    let defaultProductOption = null;

    // Look for the first product in the sorted list (which should be the default based on creator order)
    if (tempProductsDetailsList[0] && tempProductsList[0]) {
      defaultProduct = tempProductsDetailsList[0];
      defaultProductOption = tempProductsList[0];
    }

    console.log('is general product===========', defaultProduct, defaultProductOption);
    if (defaultProduct && defaultProductOption) {
      // console.log('is general product===========', defaultProduct);
      setIsGeneralProduct(defaultProduct.usd === 1);
      setCurrentProduct(defaultProductOption);
      setSelectedProduct(defaultProduct); // Set to actual product details, not dropdown option
    }
    setProductsList(tempProductsList);
    setAllProducts(tempProductsDetailsList);
    setIsLoaded(true);
    setHasValidatedProduct(true);
  };
  /* ------------------------------- Start hooks ------------------------------ */
  const countryData = useMemo(() => {
    // console.log('selected product===', selectedProduct);
    if (!(selectedProduct?.name || selectedProduct?.label)) {
      return {
        description: '',
        dropDownList: [],
        country: null,
        banner: null,
      };
    }
    const safeCountries = Array.isArray(countriesInfo) ? countriesInfo : [];
    // Match selected product name with a country
    // const selectedCountry = safeCountries.find(cb => (selectedProduct?.name || selectedProduct?.label).toLowerCase().includes(cb.country.toLowerCase()));
    // Match by creator safely
    const selectedCountry = safeCountries.find(cb => selectedProduct?.creator?.toLowerCase() === cb?.creator?.toLowerCase());    
    return {
      description: selectedCountry?.description || '',
      dropDownList: selectedCountry ? [...new Set(safeCountries.map(cb => cb.creator))] : [],
      country: selectedCountry?.country || null,
      banner: selectedCountry ? { image: selectedCountry.image, alt: selectedCountry.alt } : null,
    };
  }, [selectedProduct, countriesInfo]);

  // Update description
  useEffect(() => {
    setFinalDescription(prev => (prev !== countryData.description ? countryData.description : prev));
  }, [countryData.description]);

  // Save selected country in localStorage
  useEffect(() => {
    if (!countryData.country) return;
    // Normalize selected country
    const selected = countryData.country.toLowerCase();
    // Get all crisis_countries divs
    const allDivs = document.querySelectorAll('.crisis_countries');
    console.log('useeffect 2', selected, allDivs);
    allDivs.forEach(div => {
      if (div.id.toLowerCase() === selected) {
        div.style.display = 'block';
      } else {
        div.style.display = 'none';
      }
    });
  }, [countryData.country]);

  useEffect(() => {
    const checkMobile = () => {
      if (window.innerWidth <= 768) {
        setHideFlagState(true);
      } else {
        setHideFlagState(hideFlag);
      }
    };
    checkMobile(); // run on mount
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, [hideFlag]);
  useEffect(() => {
    products && Object.keys(products).length && getAllProducts(products);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);
  useEffect(() => {
    selectedCurrencyStore ? setCurrentCurrency(selectedCurrencyStore) : setCurrentCurrency('AUD');
  }, [selectedCurrencyStore]);

  useEffect(() => {
    if (!suggestedPrices) return;

    const parsedPrices = suggestedPrices
      .split(',')
      .map(price => parseInt(price.trim(), 10))
      .filter(price => !isNaN(price) && price > 0);

    if (parsedPrices.length === 0) return;

    setPriceOptions(prev => (JSON.stringify(prev) !== JSON.stringify(parsedPrices) ? parsedPrices : prev));

    if (!parsedPrices.includes(selectedPrice)) {
      setSelectedPrice(parsedPrices[0]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [suggestedPrices]);

  useEffect(() => {
    if (countriesInfo[0] && countriesInfo[0].creator) {
      setDefaultPriceGeneral(1);
    }
  }, [countriesInfo]);

  useEffect(() => {
    setIsLoadedImage(false); // reset whenever image changes
  }, [countryData.banner?.image]);
  return (
    <div className="flex flex-col gap-4 w-full">
      {/* Image with previous fallback */}
      {console.log('bannerssss====', countryData)}
      <div className="relative w-full h-auto min-h-[150px]">
        {prevImage && prevImage !== countryData.banner?.image && (
          <img src={prevImage} alt="" className="absolute top-0 left-0 w-full h-auto opacity-100" />
        )}
        {countryData.banner && (
          <img
            key={countryData.banner.image}
            src={countryData.banner.image}
            alt={countryData.banner.alt || ''}
            className={`fade-img ${isLoadedImage ? 'loaded' : ''}`}
            onLoad={() => {
              setIsLoadedImage(true);
              setPrevImage(countryData.banner.image);
            }}
          />
        )}
      </div>
      {/* Recurring modes (Monthly / Single) */}
      <div className="flex gap-2 w-full justify-center">
        {suggestedRecurringModes.map((modeOption, index) => (
          <button
            key={index}
            className={`flex-1 text-center h-12 font-bold text-xl transition-all duration-200 border border-[#cccac5] ${
              selectedRecurring.value === modeOption.value ? 'bg-[#F60362] !text-white' : 'bg-white text-[#F60362]'
            }`}
            onClick={() => setSelectedRecurring(modeOption)}
          >
            {modeOption.label}
          </button>
        ))}
      </div>
      {/* Product Select (Orphans Around the World) */}
      {/* {console.log('country data==', countryData, productsList, currentProduct, selectedProduct)} */}
      {currentProduct.label ? (
        <ReactSelect
          options={productsList}
          className={`max-h-[48px] w-full border gaza_select_campaign sm:min-w-[260px] uppercase [&>div]:!rounded-none`}
          value={currentProduct}
          isSearchable={false}
          styles={styles}
          placeholder="Select Product"
          onChange={e => handleSelectedProduct(e)}
          classNamePrefix="orphan_select"
        />
      ) : (
        <ReactSelect
          options={productsList}
          className={`max-h-[48px] w-full border gaza_select_campaign sm:min-w-[260px] uppercase [&>div]:!rounded-none`}
          value={productsList[0]}
          isSearchable={false}
          styles={styles}
          placeholder="Select Product"
          onChange={e => handleSelectedProduct(e)}
          classNamePrefix="orphan_select"
        />
      )}

      <div className="my-4 text-center flex flex-col gap-2 font-montserrat">
        {title && !hideTitle && <p className="text-[#00a3da] font-bold text-xl uppercase">{title}</p>}
        <p className="text-[#78716C] text-base md:text-lg font-medium text-left sm:text-center sm:m-0">{finalDescription}</p>
        <div className="flex flex-col gap-1">
          <p className="text-[#14a2dc] text-lg font-montserratBold">
            {!isGeneralProduct &&
              ShowCurrencies(currentCurrency, selectedProduct[currentCurrency.toLowerCase()] * (selectedProduct.quantity || 1), true)}
          </p>
        </div>
      </div>
      {/* {console.log('has validate==', hasValidatedProduct, isGeneralProduct)} */}
      {!hasValidatedProduct ? (
        <div className="h-40 flex items-center justify-center">
          <div className="spinner" />
        </div>
      ) : isGeneralProduct ? (
        <>
          {/* Suggested Prices */}
          <div className="w-full flex flex-wrap gap-2">
            {priceOptions.map((price, index) => {
              return (
                <div key={`prices${index}`} className="flex-1">
                  <div
                    className={`h-12 w-full transition-all duration-200 cursor-pointer flex justify-center items-center py-2 md:py-4 px-1 md:px-2 md:text-lg lg:hover:bg-[#F60362] lg:hover:text-white border border-[#cccac5] ${
                      selectedPrice === price ? 'bg-[#F60362]' : 'bg-white'
                    } ${selectedPrice === price ? '!text-white' : 'text-[#F60362]'}`}
                    onClick={() => {
                      setSelectedPrice(price);
                      setProductAmount(price);
                    }}
                  >
                    {ShowCurrencies(currentCurrency, price, true)}
                  </div>
                </div>
              );
            })}
          </div>

          {/* Custom Amount Input and Currency Select */}
          <div className={`hidden !h-[7000px] !overflow-visible`}></div>
          <div className={`flex gap-2 w-full border border-[#f60362] bg-white`}>
            <input
              value={isInputChanged ? productAmount : ''}
              className={`w-full p-2 text-lg outline-none focus:ring-1 ring-transparent border-transparent min-w-[156px] border border-[#cccac6] placeholder:text-[#F60362] text-[#F60362]`}
              placeholder={`Any Amount: ${productAmount && getSymbolFromCurrency(currentCurrency)}${productAmount}`}
              type="number"
              min="0"
              onKeyDown={handleAmountKeyDown}
              onChange={handleAmountChange}
            />
            <div className={`min-w-[100px] ${!hideFlagState && 'min-w-[140px]'}`} dir="ltr">
              <SelectCurrency
                onChangeCurrency={e => setCurrentCurrency(e.value)}
                classNamePrefix="orphan_select"
                hideFlag={hideFlagState}
                className={`[&>div]:!rounded-none`}
              />
            </div>
          </div>

          {/* Donate Now Button */}
          <button
            className={`text-white w-full text-sm md:text-lg transition-all duration-200 flex items-center justify-center h-12 px-5 ${
              isLoaded ? 'bg-[#f60362]' : 'bg-stone-300 cursor-not-allowed'
            }`}
            onClick={handleAddNewProduct}
          >
            DONATE NOW
          </button>
        </>
      ) : (
        <ProductBoxMini
          key={`product-${selectedProduct.creator}`}
          product={selectedProduct}
          onCheck={handleCheckProduct}
          onAdd={handleAddToGivingCart}
          onRemove={handleRemoveProduct}
          currency={selectedCurrencyStore}
          stateVariableObj={{ productName: selectedProduct.name }}
          _lang={'eng'}
          linkBtnClasses={selectedProduct.linkBtnClasses || ''}
          isStaticProduct={['Zakat Calculator'].includes(selectedProduct.product_type)}
          staticLink={selectedProduct.product_type ? selectedProduct.short_description : ''}
          staticLinkText={selectedProduct.product_type ? selectedProduct.name : ''}
          isSquared={true}
          recurring={selectedRecurring.value}
          totalBundlesToBeAchieved={''}
          setProductQty={setProductQty}
          defaultPriceGeneral={defaultPriceGeneral}
          deliveredDescription={''}
          showCounter={false}
          showCustomCounter={false}
          customDeliveredDescription={''}
          setCurrentCurrency={setCurrentCurrency}
          hideFlag={hideFlag}
          productQty={productQty}
          pricingFilter={pricingFilter}
        />
      )}
    </div>
  );
};

Builder.registerComponent(CountriesWidget, {
  name: 'CountriesWidget',
  inputs: [
    {
      name: 'countriesInfo',
      type: 'list',
      friendlyName: 'Countries Info',
      helperText: 'Add banner and description for specific countries',
      itemType: 'object',
      subFields: [
        {
          name: 'country',
          type: 'string',
          helperText: 'Country Name (e.g. Yemen, Syria)',
          required: true,
        },
        {
          name: 'creator',
          type: 'string',
          helperText: 'Product creator code for the country',
          required: true,
        },
        {
          name: 'description',
          type: 'string',
          helperText: 'Description',
          required: true,
        },
        {
          name: 'image',
          type: 'file',
          required: true,
          allowedFileTypes: ['png', 'jpg', 'jpeg', 'webp'],
        },
        {
          name: 'alt',
          type: 'string',
          helperText: 'Alt text for banner image',
        },
      ],
    },
    {
      name: 'defaultPrice',
      type: 'number',
      defaultValue: 70,
      friendlyName: 'Default Donation Amount',
    },
    {
      name: 'suggestedPrices',
      type: 'string',
      helperText: 'Comma-separated list of suggested prices (e.g., "100,150,200,500")',
    },
    {
      name: 'title',
      type: 'string',
      defaultValue: '',
      friendlyName: 'Title',
    },
    {
      name: 'hideTitle',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Wheter to Show or Hide Title',
    },
    {
      name: 'addToCart',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Enable Side Cart Add',
    },
    {
      name: 'pricingFilter',
      type: 'boolean',
      defaultValue: false,
      friendlyName: 'Enable Pricing Filter',
    },
    {
      name: 'hideFlag',
      type: 'boolean',
      defaultValue: true,
      friendlyName: 'Hide Country Flags (Toggle)',
    },
  ],
});

export default CountriesWidget;
